import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useMemo, useEffect } from "react";
import "./category-field-dropdown-core.scss";
import { classNameParserCore } from "../../../coreFunctions/classNameParserCore/classNameParserCore";
import { TextCore } from "../../TextCore/TextCore";
export function CategoryFieldsDropdownCore({ keyOptions, valueOptionsGetter, onChange, className, selectedOptionsMapping, categoriesLabelGetter, valueOptionsLabelGetter, }) {
    var _a;
    const [categorySelections, setCategorySelections] = useState(selectedOptionsMapping);
    const [selectedValues, setSelectedValues] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const [activeTypeId, setActiveTypeId] = useState();
    const containerRef = useRef(null);
    const selectedCategoryInExistingKeys = useMemo(() => {
        if (!selectedCategory)
            return null;
        const categoryInExistingKeys = keyOptions.find((categoryOption) => categoryOption.id === selectedCategory);
        return categoryInExistingKeys ? categoryInExistingKeys.category : null;
    }, [selectedCategory, keyOptions]);
    const valueOptions = useMemo(() => {
        if (!selectedCategoryInExistingKeys)
            return [];
        return valueOptionsGetter(selectedCategoryInExistingKeys);
    }, [selectedCategoryInExistingKeys, valueOptionsGetter]);
    useEffect(() => {
        var _a;
        if ((keyOptions === null || keyOptions === void 0 ? void 0 : keyOptions.length) > 0 && selectedCategory === undefined) {
            handleCategoryClick((_a = keyOptions === null || keyOptions === void 0 ? void 0 : keyOptions[0]) === null || _a === void 0 ? void 0 : _a.id);
        }
    }, [keyOptions]);
    const handleCategoryClick = (id) => {
        if (selectedCategory === id) {
            return;
        }
        if (selectedCategory) {
            setCategorySelections((prevSelections) => {
                const updatedSelections = Object.assign({}, prevSelections);
                if (selectedValues.length === 0) {
                    delete updatedSelections[selectedCategory];
                }
                else {
                    updatedSelections[selectedCategory] = selectedValues;
                }
                return updatedSelections;
            });
        }
        setSelectedCategory(id);
        const selectionsForNewType = (selectedOptionsMapping === null || selectedOptionsMapping === void 0 ? void 0 : selectedOptionsMapping[id]) || [];
        setSelectedValues(selectionsForNewType);
    };
    const handleContainerMouseLeave = (event) => {
        const container = containerRef.current;
        if (container && !container.contains(event.relatedTarget)) {
            if (selectedCategory) {
                const selectionsToOutput = Object.assign({}, categorySelections);
                if (selectedValues.length === 0) {
                    delete selectionsToOutput[selectedCategory];
                }
                else {
                    selectionsToOutput[selectedCategory] = selectedValues;
                }
                onChange(selectionsToOutput);
                setCategorySelections(selectionsToOutput);
            }
            if (activeTypeId !== selectedCategory) {
                setActiveTypeId(selectedCategory);
            }
        }
    };
    const toggleSelectedValue = (id) => {
        if (!selectedCategory)
            return;
        const currentSet = new Set(selectedValues);
        const isSelected = currentSet.has(id);
        if (isSelected) {
            currentSet.delete(id);
        }
        else {
            currentSet.add(id);
        }
        const updatedSelectedValuesArray = Array.from(currentSet);
        setSelectedValues(updatedSelectedValuesArray);
        const newCategorySelections = Object.assign(Object.assign({}, categorySelections), { [selectedCategory]: updatedSelectedValuesArray });
        setCategorySelections(newCategorySelections);
    };
    return (_jsxs("div", { className: classNameParserCore("category-value-dropdown-container", className), ref: containerRef, onMouseLeave: handleContainerMouseLeave, children: [_jsx("div", { className: "category-list", children: (_a = (keyOptions || Object.keys(selectedOptionsMapping || {}))) === null || _a === void 0 ? void 0 : _a.map((key) => (_jsx("div", { className: classNameParserCore("category-item", {
                        "is-selected": selectedCategory === key.id,
                    }), onClick: () => handleCategoryClick(key.id), children: _jsx(TextCore, { text: categoriesLabelGetter(key.category), fontWeight: "bold" }) }, String(key.id)))) }), _jsx("div", { className: "value-list", children: selectedCategory !== null &&
                    (valueOptions && valueOptions.length > 0 ? (valueOptions.map((value) => (_jsxs("div", { className: "value-item", onClick: () => toggleSelectedValue(value.id), children: [_jsx("input", { type: "checkbox", checked: selectedValues.includes(value.id), onChange: () => toggleSelectedValue(value.id) }), _jsx(TextCore, { text: valueOptionsLabelGetter(value.id) })] }, String(value.id))))) : (_jsx("div", { className: "value-empty-state", children: _jsx(TextCore, { text: "No fields found for this category." }) }))) })] }));
}
